import { render, staticRenderFns } from "./Cam.vue?vue&type=template&id=20a1df67"
import script from "./Cam.vue?vue&type=script&lang=js"
export * from "./Cam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports